import { render, staticRenderFns } from "./PurchaseInvoiceDetail.vue?vue&type=template&id=320832e0&"
import script from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports